export const CONVERSATION_STARTED = 'conversationStarted';
export const CONVERSATION_CLOSED = 'conversationClosed';
export const UNREAD_CONVERSATION_COUNT_CHANGED = 'unreadConversationCountChanged';
export const INPUT_STAGING = 'inputStaging';
export const CONTACT_ASSOCIATED = 'contactAssociated';
export const EMAIL_CAPTURED = 'emailCaptured';
export const USER_INTERACTED_WITH_WIDGET = 'userInteractedWithWidget';
export const QUICK_REPLY_BUTTON_CLICK = 'quickReplyButtonClick';
export const QUICK_LINK_BUTTON_CLICK = 'quickLinkButtonClick';
export const WIDGET_LOADED = 'widgetLoaded';
export const WIDGET_CLOSED = 'widgetClosed';
export const USER_SELECTED_THREAD = 'userSelectedThread';
export const WIDGET_HIDDEN = 'widgetHidden';
export const SDK_CLOSE_BUTTON_CLICK = 'sdkCloseButtonClick';
export const MESSAGE_INPUT_STATE_CHANGED = 'messageInputStateChanged';
export const INPUT_TEXT_CHANGED = 'inputTextChanged';